import {RootState} from "@/store/Store";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface OLFToRequisitesRuleFormsInterface {
    formVisible: boolean;
    formVariant: "new" | "edit";
    editId: number | null;
    editOrgLegalFormId: number | null;
    editRequisiteId: number | null;
    deleteModalVisible: boolean;
    deleteId: number | null;
}

const getInitialState = (): OLFToRequisitesRuleFormsInterface => ({
    formVariant: "new",
    formVisible: false,
    editId: null,
    editOrgLegalFormId: null,
    editRequisiteId: null,
    deleteModalVisible: false,
    deleteId: null,
});

export const OLFToRequisitesRuleFormsSlice = createSlice({
    name: "olfToRequisitesRuleForms",
    initialState: getInitialState(),
    reducers: {
        openForm: (state, action: PayloadAction<"new" | "edit">) => {
            state.formVisible = true;
            state.formVariant = action.payload
        },
        closeForm: (state) => {
            state.formVisible = false;
        },
        changeEditId: (state, action: PayloadAction<number | null>) => {
            state.editId = action.payload;
        },
        changeEditOrgLegalFormId: (state, action: PayloadAction<number | null>) => {
            state.editOrgLegalFormId = action.payload;
        },
        changeEditRequisiteId: (state, action: PayloadAction<number | null>) => {
            state.editRequisiteId = action.payload;
        },
        openDeleteModal: (state) => {
            state.deleteModalVisible = true;
        },
        closeDeleteModal: (state) => {
            state.deleteModalVisible = false;
        },
        changeDeleteId: (state, action: PayloadAction<number | null>) => {
            state.deleteId = action.payload;
        },
        reset: () => getInitialState(),
    },
});

export const {
    openForm,
    closeForm,
    changeEditId,
    changeEditOrgLegalFormId,
    changeEditRequisiteId,
    openDeleteModal,
    closeDeleteModal,
    reset,
    changeDeleteId,
} = OLFToRequisitesRuleFormsSlice.actions;

export const selectFormVisible = (state: RootState) => state.olfToRequisitesRuleForms.formVisible;
export const selectFormVariant = (state: RootState) => state.olfToRequisitesRuleForms.formVariant;
export const selectEditId = (state: RootState) => state.olfToRequisitesRuleForms.editId;
export const selectEditOrgLegalFormId = (state: RootState) => state.olfToRequisitesRuleForms.editOrgLegalFormId;
export const selectEditRequisiteId = (state: RootState) => state.olfToRequisitesRuleForms.editRequisiteId;
export const selectDeleteModalVisible = (state: RootState) => state.olfToRequisitesRuleForms.deleteModalVisible;
export const selectDeleteId = (state: RootState) => state.olfToRequisitesRuleForms.deleteId;


export const OLFToRequisitesRuleFormsReducer = OLFToRequisitesRuleFormsSlice.reducer;
